module.exports = __webpack_public_path__ + "img/27000.7c730e16.jpg";